import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const IPay88Payment = () => {
  return <DataFormSubmitPage />;
};

export default IPay88Payment;
